import './order_online_state.css';
import { useEffect, useState } from 'react';
import { useServer } from '../../context/ServerContext';
import { businessEndpoints } from '../../env';
import { useBusiness } from '../../context/BusinessContext';

export const OrderOnlineState = () => {
    //HOOKS
    const { getRequest } = useServer();
    

    //STATES
    const [open, setOpen] = useState(true);
    const [businessInfo, setBusinessInfo] = useState(null);

    //FUNCTIONS 
    const getOpen = () => {
        getRequest(businessEndpoints.get_active, {}, ([status, res]) => {
            if (status)
            {
                setOpen(res.active);
            }
        });
    }

    const getBusinessInfo = () => {
        getRequest(businessEndpoints.get_info, {}, ([status, res]) => {
            if (status)
            {
                setBusinessInfo(res.business_info);
            }
        });
    }

    //EFFECTS
    useEffect(() => {
        const interval = setInterval(() => {
            getOpen();
        }, 3000);
        
        return () => clearInterval(interval);
    }, []);

    useEffect(() => {
        getBusinessInfo();
    }, []);

    return (
        <section className={open ? "notify_section" : "notify_section active"}>
            <div className="notify_contain">
                <div className="title_contain">
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <g id="clock">
                            <circle id="Ellipse" cx="10" cy="10" r="9" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></circle>
                            <path id="Vector 58" d="M10 10L12 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                            <path id="Vector 58_2" d="M10.0007 9.70786L10 6" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"></path>
                        </g>
                    </svg>
                    <h2>Sorry, we are closed</h2>
                </div>
                <div className="info_contain">
                    <p>
                        { businessInfo != null && businessInfo.business_hours}
                    </p>
                </div>
            </div>
        </section>
    );
}